import React, { useState, useMemo, useCallback } from "react";
import "../../theme/redesign/tokens.css";
import "../../theme/redesign/section.css";
import "../../theme/redesign/productions.css";
import BackendProductionsNonmetallic from "./BackendProductionsNonmetallic";
import ProductionsTableNonmetallic from "./ProductionsTableNonmetallic";
import useProductionsLogicNonmetallic from "./useProductionsLogicNonmetallic";
import useTooltipLogic from "./useTooltipLogic";
import DeliveryMethodsNonmetallic from "./DeliveryMethodsNonmetallic";
import Slider from "@mui/material/Slider";

// Chrome-like tabs CSS
const chromeTabsStyles = `
  .chrome-tabs::-webkit-scrollbar {
    display: none;
  }
  .chrome-tabs {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .chrome-tab:hover:not(.active) {
    background-color: #e9ecef !important;
    color: #495057 !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
  }
  .chrome-tab:active {
    transform: translateY(0);
  }
  .chrome-tab.active {
    background-color: #ffffff !important;
    color: #333 !important;
  }
  @media (max-width: 768px) {
    .chrome-tabs {
      padding: 2px 2px 0 2px;
    }
    .chrome-tab {
      margin: 0 0.5px !important;
      min-width: 100px !important;
      font-size: 12px !important;
    }
  }

  /* Карточка фильтра Mkr/Kf под токены редизайна (frame-25 в плане).
     Все три карточки одинаковой ширины (260px), «Способ доставки» отжимается
     к правому краю через margin-left:auto. */
  .mkr-slider-container {
    background: #ffffff;
    border: 1px solid #e6ecf3;
    border-radius: 14px;
    padding: 14px 16px;
    flex: 0 0 260px;
    min-width: 0;
    min-height: 92px;
    box-sizing: border-box;
    box-shadow: 0 1px 2px rgba(2, 2, 23, 0.04);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .mkr-slider-title {
    font-size: 11px;
    font-weight: 700;
    color: #7a8aa3;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .mkr-slider-values {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 8px;
  }
  .mkr-slider-value {
    background: #e9ecef;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 500;
  }
  .mkr-range-slider {
    width: 100%;
    height: 6px;
    border-radius: 3px;
    background: #dee2e6;
    outline: none;
    cursor: pointer;
  }

  /* Распределяем 3 карточки по ширине: МКР слева, КФ по центру,
     Способ доставки справа. Высоты одинаковые. */
  .nerudka-filters-row {
    margin-bottom: 18px;
    width: 100% !important;
    align-items: stretch !important;
    justify-content: space-between !important;
    gap: 12px !important;
  }

  /* Контейнер «Способ доставки» — фикс-ширина 260px + margin-left:auto:
     - когда МКР/КФ есть → margin-left:auto работает как доп. push вправо
       (поверх justify-content родителя);
     - когда МКР/КФ нет (например, для «камень бутовый») → один лишь Способ
       тоже улетает к правому краю. */
  .delivery-methods-nonmetallic.mkr-slider-container {
    flex: 0 0 260px;
    margin-left: auto;
  }

  /* Внутренний bare-select из components/Dropdown.js перекрашиваем */
  .delivery-methods-nonmetallic select {
    width: 100% !important;
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    padding: 10px 38px 10px 14px !important;
    font-family: "Inter", -apple-system, system-ui, "Segoe UI", Roboto, Arial, sans-serif !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #020217 !important;
    background-color: #ffffff !important;
    border: 1px solid #dbe3ef !important;
    border-radius: 10px !important;
    box-shadow: 0 1px 2px rgba(2, 2, 23, 0.05) !important;
    cursor: pointer !important;
    transition: border-color 0.15s, box-shadow 0.15s !important;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%234a5875'><path d='M6 9l6 6 6-6z'/></svg>") !important;
    background-repeat: no-repeat !important;
    background-position: right 12px center !important;
    background-size: 14px !important;
  }
  .delivery-methods-nonmetallic select:focus {
    outline: none !important;
    border-color: #1f7fd1 !important;
    box-shadow: 0 0 0 3px rgba(31, 127, 209, 0.18) !important;
  }

  /* Inline «Способ доставки» в шапке секции — компактная карточка справа от h2 */
  .rd-sec-head.rd-sec-head--inline-delivery {
    align-items: flex-start;
  }
  .rd-sec-head.rd-sec-head--inline-delivery > .delivery-methods-nonmetallic.mkr-slider-container {
    flex: 0 0 280px;
    padding: 12px 14px;
    min-height: 0;
    margin-top: -4px;
  }
  .rd-sec-head.rd-sec-head--inline-delivery .mkr-slider-title {
    margin-bottom: 6px;
  }

`;

const _catFaceUrl = `url("${process.env.PUBLIC_URL}/flask-cork-thumb.svg")`;

// Тайл-заливка с волнистым нижним краем: цвет блика доходит ровно до линии
// волны и двигается вместе с ней, имитируя рябь на поверхности жидкости
const _waveTileUrl = (opacity, baseY, amplitude, fill = 'white') => {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='44' height='14' viewBox='0 0 44 14'>` +
    `<path d='M-4,0 L-4,${baseY} C 7,${baseY - amplitude} 7,${baseY + amplitude} 18,${baseY} ` +
    `C 29,${baseY - amplitude} 29,${baseY + amplitude} 40,${baseY} C 44,${baseY - amplitude / 2} 44,${baseY - amplitude / 2} 48,${baseY} ` +
    `L48,0 Z' fill='${fill}' fill-opacity='${opacity}'/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

const _branchSliderSx = (primaryHue) => ({
  width: '140px',
  position: 'relative',
  '& .MuiSlider-rail': {
    height: 14,
    borderRadius: '7px',
    opacity: 1,
    background: 'linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(225,235,242,0.55) 40%, rgba(210,222,232,0.5) 60%, rgba(255,255,255,0.75) 100%)',
    border: '1px solid rgba(170, 190, 205, 0.5)',
    boxShadow: 'inset 0 2px 3px rgba(85, 80, 100, 0.18), inset 0 -1px 2px rgba(255, 255, 255, 0.6)',
    zIndex: 1,
  },
  '& .MuiSlider-track': {
    height: 14,
    border: `1px solid hsla(${primaryHue},45%,35%,0.35)`,
    borderRadius: '7px',
    position: 'relative',
    overflow: 'hidden',
    zIndex: 1,
    // Слой 1 — передняя рябь, слой 2 — задняя рябь (глубина), слой 3 — сама жидкость
    backgroundImage: [
      _waveTileUrl(0.6, 5.5, 3),
      _waveTileUrl(0.35, 4, 2.6),
      `linear-gradient(180deg,
        hsla(${primaryHue},80%,92%,0.95) 0%,
        hsl(${primaryHue},75%,68%) 20%,
        hsl(${primaryHue},70%,52%) 55%,
        hsl(${primaryHue},72%,40%) 100%)`,
    ].join(', '),
    backgroundRepeat: 'repeat-x, repeat-x, no-repeat',
    backgroundSize: '44px 100%, 58px 100%, 100% 100%',
    backgroundPosition: '0 top, 0 top, 0 0',
    animation: 'cg-wave-layers 2.8s linear infinite',
    boxShadow: `inset 0 -3px 4px hsla(${primaryHue},70%,25%,0.5), inset 0 2px 2px rgba(255,255,255,0.75), 0 0 3px hsla(${primaryHue},55%,40%,0.35)`,
    '&::before': {
      // Пузырьки — цвет жидкости, но светлее, с бликом-ядром и свечением по краю;
      // своя независимая анимация: дрейф + покачивание вверх-вниз
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundImage: [
        `radial-gradient(circle 3.2px at 10% 42%, rgba(255,255,255,0.95) 0%, hsla(${primaryHue},95%,82%,0.7) 30%, hsla(${primaryHue},95%,70%,0.28) 60%, transparent 85%)`,
        `radial-gradient(circle 2.2px at 20% 72%, rgba(255,255,255,0.9) 0%, hsla(${primaryHue},95%,80%,0.6) 35%, hsla(${primaryHue},95%,68%,0.2) 65%, transparent 90%)`,
        `radial-gradient(circle 4px at 30% 52%, rgba(255,255,255,0.9) 0%, hsla(${primaryHue},95%,82%,0.65) 30%, hsla(${primaryHue},95%,68%,0.22) 62%, transparent 88%)`,
        `radial-gradient(circle 2.5px at 40% 30%, rgba(255,255,255,0.85) 0%, hsla(${primaryHue},95%,80%,0.55) 35%, hsla(${primaryHue},95%,68%,0.18) 65%, transparent 90%)`,
      ].join(', '),
      backgroundSize: '42px 100%',
      backgroundRepeat: 'repeat',
      mixBlendMode: 'screen',
      animation: 'cg-bubble-drift 3.6s linear infinite, cg-bubble-bob 1.7s ease-in-out infinite',
      pointerEvents: 'none',
    },
    '&::after': {
      // Блёстки — своя независимая анимация: мерцание + медленный дрейф
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundImage: [
        'radial-gradient(circle 0.8px at 14% 25%, rgba(255,255,255,0.95) 0%, transparent 100%)',
        'radial-gradient(circle 0.6px at 24% 60%, rgba(255,255,255,0.9) 0%, transparent 100%)',
      ].join(', '),
      backgroundSize: '30px 100%',
      backgroundRepeat: 'repeat',
      animation: 'cg-sparkle-pulse 1.8s ease-in-out infinite, cg-sparkle-drift 5s linear infinite',
      pointerEvents: 'none',
    },
  },
  '& .MuiSlider-thumb': {
    width: 32,
    height: 32,
    backgroundColor: 'transparent',
    backgroundImage: _catFaceUrl,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    border: 'none',
    boxShadow: 'none',
    filter: 'drop-shadow(0 2px 3px rgba(0,0,0,0.25))',
    zIndex: 2,
    '&::before': { display: 'none' },
  },
  '& .MuiSlider-valueLabel': {
    backgroundColor: '#6a4020',
    borderRadius: '8px',
    fontSize: '11px',
    padding: '3px 7px',
    fontFamily: '"Inter", system-ui, sans-serif',
    zIndex: 3,
  },
});

// Обычный (не кошко-девочковый) вид ползунков — плоский MUI-слайдер без темы
const _plainMkrSliderSx = {
  width: '140px',
  color: '#198754',
  '& .MuiSlider-thumb': {
    width: 16,
    height: 16,
    '&:hover, &.Mui-focusVisible': {
      boxShadow: '0 0 0 8px rgba(25, 135, 84, 0.16)',
    },
  },
  '& .MuiSlider-track': {
    height: 4,
  },
  '& .MuiSlider-rail': {
    height: 4,
    opacity: 0.24,
  },
};

const _plainKfSliderSx = {
  width: '140px',
  color: '#0d6efd',
  '& .MuiSlider-thumb': {
    width: 16,
    height: 16,
    '&:hover, &.Mui-focusVisible': {
      boxShadow: '0 0 0 8px rgba(13, 110, 253, 0.16)',
    },
  },
  '& .MuiSlider-track': {
    height: 4,
  },
  '& .MuiSlider-rail': {
    height: 4,
    opacity: 0.24,
  },
};

function ProductionsNonmetallic({
  products,
  paymentMethod,
  deliveryMethod,
  setDeliveryMethod,
  addressAndCoordinates,
  selfPickUp,
  setComparisons,
  comparisons,
  setSelectedOffer,
  offerRef,
  selectedRegion,
  nonmetallicDeliveryMethods,
  setNonmetallicDeliveryMethods,
  addressValidationError,
  setAddressValidationError,
  setProductErrors,
  isCatMode
}) {
  // Получаем список продуктов из нерудки для создания вкладок
  const nonmetallicProducts = useMemo(() => {
    return products.filter(product => {
      return product.name && product.category === "Нерудные материалы";
    });
  }, [products]);

  // Состояние активной вкладки
  const [activeTab, setActiveTab] = useState(0); // Отдельное состояние для сравнений нерудки (по продуктам)
  const [nonmetallicComparisons, setNonmetallicComparisons] = useState({});
  // nonmetallicDeliveryMethods теперь передается из App.js

  // Получаем активный продукт для текущей вкладки
  const activeProduct = nonmetallicProducts[activeTab];

  // Состояние фильтра по модулю крупности (mkr) - для каждого продукта свой фильтр
  const [mkrFilters, setMkrFilters] = useState({});

  // Состояние фильтра по коэффициенту фильтрации (kf) - для каждого продукта свой фильтр
  const [kfFilters, setKfFilters] = useState({});

  // Получаем фильтр для активного продукта
  const currentMkrFilter = useMemo(() => {
    if (!activeProduct) return { min: 0.5, max: 4.0 };
    return mkrFilters[activeProduct.name] || { min: 0.5, max: 4.0 };
  }, [activeProduct, mkrFilters]);

  // Получаем фильтр Кф для активного продукта
  const currentKfFilter = useMemo(() => {
    if (!activeProduct) return { min: 0.5, max: 20.0 };
    return kfFilters[activeProduct.name] || { min: 0.5, max: 20.0 };
  }, [activeProduct, kfFilters]);

  // Устанавливаем фильтр Мкр для активного продукта
  const setCurrentMkrFilter = useCallback((newFilter) => {
    if (!activeProduct) return;
    setMkrFilters(prev => ({
      ...prev,
      [activeProduct.name]: typeof newFilter === 'function' ? newFilter(prev[activeProduct.name] || { min: 0.5, max: 4.0 }) : newFilter
    }));
  }, [activeProduct]);

  // Устанавливаем фильтр Кф для активного продукта
  const setCurrentKfFilter = useCallback((newFilter) => {
    if (!activeProduct) return;
    setKfFilters(prev => ({
      ...prev,
      [activeProduct.name]: typeof newFilter === 'function' ? newFilter(prev[activeProduct.name] || { min: 0.5, max: 20.0 }) : newFilter
    }));
  }, [activeProduct]);

  // Обрабатываем случай удаления активной вкладки
  React.useEffect(() => {
    if (nonmetallicProducts.length > 0 && activeTab >= nonmetallicProducts.length) {
      console.log(`🗑️ Активная вкладка ${activeTab} больше не существует, переключаемся на последнюю`);
      setActiveTab(nonmetallicProducts.length - 1);
    } else if (nonmetallicProducts.length === 0) {
      console.log('🗑️ Все материалы удалены');
      setActiveTab(0);
    }
  }, [nonmetallicProducts.length, activeTab]);

  // Очистка данных для удаленных материалов
  React.useEffect(() => {
    const existingMaterialNames = nonmetallicProducts.map(p => p.name);

    // Очищаем сравнения для удаленных материалов
    setNonmetallicComparisons(prev => {
      const cleaned = {};
      Object.keys(prev).forEach(materialName => {
        if (existingMaterialNames.includes(materialName)) {
          cleaned[materialName] = prev[materialName];
        } else {
          console.log(`🗑️ Очищены сравнения для удаленного материала: ${materialName}`);
        }
      });
      return cleaned;
    });

    // Очищаем методы доставки для удаленных материалов
    if (setNonmetallicDeliveryMethods) {
      setNonmetallicDeliveryMethods(prev => {
        const cleaned = {};
        Object.keys(prev).forEach(materialName => {
          if (existingMaterialNames.includes(materialName)) {
            cleaned[materialName] = prev[materialName];
          } else {
            console.log(`🗑️ Очищен метод доставки для удаленного материала: ${materialName}`);
          }
        });
        return cleaned;
      });
    }
  }, [nonmetallicProducts, setNonmetallicDeliveryMethods]);

  // Фильтруем продукты только для активной вкладки
  const currentProducts = useMemo(() => {
    return activeProduct ? [activeProduct] : [];
  }, [activeProduct]);

  // Получаем сравнения для активного продукта
  const currentComparisons = useMemo(() => {
    return activeProduct
      ? (nonmetallicComparisons[activeProduct.name] || [])
      : [];
  }, [activeProduct, nonmetallicComparisons]);

  // Получаем способ доставки для активного продукта
  const currentDeliveryMethod = useMemo(() => {
    if (!activeProduct) {
      console.log('🚚 currentDeliveryMethod: нет активного продукта, возвращаем deliveryMethod');
      return deliveryMethod;
    }

    // Для каждого материала используем индивидуальный способ доставки или дефолтный для нерудки
    const materialDeliveryMethod = nonmetallicDeliveryMethods[activeProduct.name];
    const result = materialDeliveryMethod || "Оптимальный маршрут";

    console.log('🚚 currentDeliveryMethod for', activeProduct?.name, ':', result);
    console.log('🚚 nonmetallicDeliveryMethods:', nonmetallicDeliveryMethods);
    console.log('🚚 materialDeliveryMethod for', activeProduct?.name, ':', materialDeliveryMethod);
    console.log('🚚 currentDeliveryMethod пересчитан, result:', result);

    return result;
  }, [activeProduct, nonmetallicDeliveryMethods, deliveryMethod]);

  // Функция для обновления сравнений активного продукта
  const setCurrentComparisons = useCallback((newComparisons) => {
    if (!activeProduct) return;

    setNonmetallicComparisons(prev => {
      const updatedComparisons = {
        ...prev,
        [activeProduct.name]: newComparisons
      };

      // Объединяем все сравнения из всех вкладок для общего состояния
      const allComparisons = Object.values(updatedComparisons).flat();
      console.log('🧮 setCurrentComparisons объединение:', {
        activeProduct: activeProduct?.name,
        newComparisons: newComparisons.length,
        updatedComparisons,
        allComparisons: allComparisons.length
      });
      setComparisons(allComparisons);

      return updatedComparisons;
    });
  }, [activeProduct, setComparisons]);

  // Функция для обновления способа доставки активного продукта
  const setCurrentDeliveryMethod = useCallback((newDeliveryMethodOrFunction) => {
    if (!activeProduct) return;

    console.log('🚚 ProductionsNonmetallic setCurrentDeliveryMethod:', newDeliveryMethodOrFunction);

    setNonmetallicDeliveryMethods(prev => {
      // Если передана функция, выполняем её с текущим значением для продукта
      const currentValue = prev[activeProduct.name] || "Оптимальный маршрут";
      const newValue = typeof newDeliveryMethodOrFunction === 'function'
        ? newDeliveryMethodOrFunction(currentValue)
        : newDeliveryMethodOrFunction;

      console.log('🚚 setCurrentDeliveryMethod: currentValue=', currentValue, 'newValue=', newValue);

      return {
        ...prev,
        [activeProduct.name]: newValue
      };
    });
  }, [activeProduct]);

  // Отслеживаем изменения nonmetallicDeliveryMethods из OfferTableNonmetallic
  React.useEffect(() => {
    if (activeProduct) {
      const newMethod = nonmetallicDeliveryMethods[activeProduct.name];
      if (newMethod && newMethod !== currentDeliveryMethod) {
        console.log(`🔄 Обновляем метод доставки для ${activeProduct.name}: ${currentDeliveryMethod} -> ${newMethod}`);
        // Принудительно обновляем метод доставки для пересчета
        setCurrentDeliveryMethod(newMethod);
      }
    }
  }, [nonmetallicDeliveryMethods, activeProduct]);

  const {
    isValidInput,
    groupedData,
    sortedGroupedData,
    hasValidDescriptions,
    minDistanceKadToClient,
    handleSelectOffer,
    setShouldScroll,
    shouldScroll,
    isLoading,
    setIsLoading,
  } = useProductionsLogicNonmetallic(
    currentProducts, // Передаем только текущий продукт
    selfPickUp,
    currentComparisons, // Используем сравнения для текущего продукта
    setCurrentComparisons, // Используем отдельную функцию обновления
    setSelectedOffer,
    offerRef
  );

  const { tooltip, handleMouseEnter, handleMouseLeave, tableContainerRef, tooltipRef } =
    useTooltipLogic();

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: chromeTabsStyles }} />
      <section className="rd-section">
        <BackendProductionsNonmetallic
          products={currentProducts}
          paymentMethod={paymentMethod}
          deliveryMethod={currentDeliveryMethod}
          addressAndCoordinates={addressAndCoordinates}
          selfPickUp={selfPickUp}
          setComparisons={setCurrentComparisons}
          comparisons={currentComparisons}
          setIsLoading={setIsLoading}
          selectedRegion={selectedRegion}
          setAddressValidationError={setAddressValidationError}
          setProductErrors={setProductErrors}
        />
        <div className="rd-sec-head rd-sec-head--inline-delivery">
          <h2>
            Сравнение стоимости производств
            <small>
              {activeProduct
                ? (nonmetallicProducts.length > 1
                  ? `${activeProduct.name} · сортировка по итоговой стоимости`
                  : `${activeProduct.name} · сортировка по итоговой стоимости`)
                : "сортировка по итоговой стоимости"}
            </small>
          </h2>
          {!selfPickUp && (
            <DeliveryMethodsNonmetallic
              deliveryMethod={currentDeliveryMethod}
              setDeliveryMethod={setCurrentDeliveryMethod}
              selectedRegion={selectedRegion}
            />
          )}
        </div>

        <div>
          <div>

            {/* Chrome-like вкладки для продуктов из нерудки */}
            {nonmetallicProducts.length > 1 && (
              <div className="chrome-tabs-container mt-3">
                <div className="chrome-tabs" style={{
                  display: 'flex',
                  borderBottom: '1px solid #dee2e6',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px 8px 0 0',
                  padding: '4px 4px 0 4px',
                  overflowX: 'auto',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none'
                }}>
                  {nonmetallicProducts.map((product, index) => {
                    const isActive = activeTab === index;

                    // Адаптивная ширина вкладок как в Chrome
                    const containerWidth = 800; // Примерная ширина контейнера
                    const tabCount = nonmetallicProducts.length;
                    const minTabWidth = 120;
                    const maxTabWidth = 240;
                    const idealTabWidth = Math.floor(containerWidth / tabCount);

                    let tabWidth;
                    if (tabCount <= 3) {
                      tabWidth = Math.min(maxTabWidth, idealTabWidth);
                    } else if (tabCount <= 6) {
                      tabWidth = Math.max(minTabWidth, idealTabWidth);
                    } else {
                      tabWidth = minTabWidth;
                    }

                    const finalTabWidth = `${tabWidth}px`;

                    return (
                      <button
                        key={product.id}
                        className={`chrome-tab ${isActive ? 'active' : ''}`}
                        onClick={() => setActiveTab(index)}
                        type="button"
                        style={{
                          width: finalTabWidth,
                          minWidth: '120px',
                          height: '36px',
                          border: 'none',
                          borderRadius: '8px 8px 0 0',
                          backgroundColor: isActive ? '#ffffff' : 'transparent',
                          color: isActive ? '#333' : '#6c757d',
                          fontSize: '13px',
                          fontWeight: isActive ? '600' : '400',
                          padding: '8px 12px',
                          margin: '0 1px',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          position: 'relative',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          boxShadow: isActive ? '0 2px 8px rgba(0,0,0,0.15)' : 'none',
                          zIndex: isActive ? 2 : 1
                        }}
                        title={`${product.name}${product.quantity ? ` (${product.quantity} ${product.unit})` : ''}`}
                      >
                        <span style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          maxWidth: '100%'
                        }}>
                          {(() => {
                            // Адаптивный текст в зависимости от ширины вкладки
                            const showQuantity = tabWidth >= 160 && product.quantity;
                            const shortName = tabWidth < 140 ? product.name.split(' ')[0] : product.name;

                            return showQuantity
                              ? `${shortName} (${product.quantity} ${product.unit})`
                              : shortName;
                          })()}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          <div className="d-flex align-items-center gap-3 nerudka-filters-row">
            {/* Фильтр по модулю крупности и Кф (только для песка) */}
            {activeProduct && (() => {
              const name = activeProduct.name?.toLowerCase() || '';
              const category = activeProduct.category?.toLowerCase() || '';
              const isSandProduct = name.includes('песок') || category.includes('песок');
              if (!isSandProduct) return null;
              return (
                <div className="d-flex gap-3">
                  {/* Фильтр Мкр */}
                  <div className="mkr-slider-container">
                    <div className="mkr-slider-title">Модуль крупности (Мкр)</div>
                    <div className="d-flex align-items-center gap-3" style={{ padding: '0 8px' }}>
                      <Slider
                        value={[currentMkrFilter.min ?? 0.5, currentMkrFilter.max ?? 4.0]}
                        onChange={(_, newValue) => {
                          setCurrentMkrFilter({
                            min: newValue[0],
                            max: newValue[1]
                          });
                        }}
                        valueLabelDisplay="auto"
                        valueLabelFormat={(v) => v.toFixed(1)}
                        min={0.5}
                        max={4.0}
                        step={0.1}
                        sx={isCatMode ? _branchSliderSx(130) : _plainMkrSliderSx}
                      />
                      <div className="d-flex align-items-center gap-1" style={{ minWidth: '70px', fontSize: '12px', color: '#6c757d' }}>
                        <span>{currentMkrFilter.min?.toFixed(1) ?? '0.5'}</span>
                        <span>—</span>
                        <span>{currentMkrFilter.max?.toFixed(1) ?? '4.0'}</span>
                      </div>
                    </div>
                  </div>

                  {/* Фильтр Кф */}
                  <div className="mkr-slider-container">
                    <div className="mkr-slider-title">Коэффициент фильтрации (Кф)</div>
                    <div className="d-flex align-items-center gap-3" style={{ padding: '0 8px' }}>
                      <Slider
                        value={[currentKfFilter.min ?? 0.5, currentKfFilter.max ?? 20.0]}
                        onChange={(_, newValue) => {
                          setCurrentKfFilter({
                            min: newValue[0],
                            max: newValue[1]
                          });
                        }}
                        valueLabelDisplay="auto"
                        valueLabelFormat={(v) => v.toFixed(1)}
                        min={0.5}
                        max={20.0}
                        step={0.5}
                        sx={isCatMode ? _branchSliderSx(280) : _plainKfSliderSx}
                      />
                      <div className="d-flex align-items-center gap-1" style={{ minWidth: '70px', fontSize: '12px', color: '#6c757d' }}>
                        <span>{currentKfFilter.min?.toFixed(1) ?? '0.5'}</span>
                        <span>—</span>
                        <span>{currentKfFilter.max?.toFixed(1) ?? '20.0'}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
        <div className="cg-nerudka-branches-wrap">
          <ProductionsTableNonmetallic
            isValidInput={isValidInput}
            isLoading={isLoading}
            sortedGroupedData={sortedGroupedData}
            mkrFilter={currentMkrFilter}
            kfFilter={currentKfFilter}
            handleSelectOffer={handleSelectOffer}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
            tooltip={tooltip}
            tableContainerRef={tableContainerRef}
            tooltipRef={tooltipRef}
            selfPickUp={selfPickUp}
          />
        </div>
      </section>
    </>
  );
}

export default ProductionsNonmetallic;
